import React, { useEffect, useState } from "react";
import "./Signin.css";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { currentUser, insertAuditStamping, login } from "../../Redux/Auth/Action";
import { fetchClientDetails } from "../../Redux/Config/Action";
import { FaEye, FaEyeSlash } from "react-icons/fa6";

const Signin = () => {

  const navigate = useNavigate();
  const [inputData, setInputData] = useState({ username: "", password: "" });
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");
  const { auth } = useSelector((store) => store);
  const { clientDetails } = useSelector((store) => store.config);
  const [errorMessage, setErrorMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handelSubmit = (e) => {
    setErrorMessage("");
    e.preventDefault();
    dispatch(login(inputData))
      .then((response) => {
        if (response.token) {
          dispatch(insertAuditStamping(inputData?.username, response.token));
          navigate("/");
        } else if (response.error) {
          setErrorMessage(response.error);
          setTimeout(() => setErrorMessage(""), 3000);
        } else {
          setErrorMessage("Something went wrong!");
          setTimeout(() => setErrorMessage(""), 3000);
        }
      })
      .catch((e) => {
        setErrorMessage("Invalid credentials. Please try again.");
        setTimeout(() => {
          setErrorMessage("");
        }, 3000);
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputData((values) => ({ ...values, [name]: value }));
  };
  useEffect(() => {
    if (token) dispatch(currentUser(token));
  }, [token, dispatch]);

  useEffect(() => {
    if (auth.reqUser?.username) {
      navigate("/");
    }
  }, [auth.reqUser, navigate]);

  useEffect(() => {
    dispatch(fetchClientDetails(token));
  }, [dispatch]);

  const clientData = clientDetails?.clientMaster?.[0];

  return (
    <div className="modern-login-wrapper">
      <div className="login-container">
        <div className="container px-3 px-md-5">
          <div className="login-card">
            <div className="row g-0">
              <div className="col-lg-6 d-none d-lg-block">
                <div className="image-side">
                  <div className="decorative-circle circle-1"></div>
                  <div className="decorative-circle circle-2"></div>
                  <div className="decorative-circle circle-3"></div>
                  <div className="decorative-circle circle-4"></div>
                  <div className="decorative-circle circle-5"></div>
                  <div className="decorative-circle circle-6"></div>
                  <div className="decorative-circle circle-7"></div>
                  <div className="image-side-content">
                    <h2>HRMS</h2>
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="form-side">
                  <div className="logo-section">
                    <div className="form-logo">
                      <img
                        src={clientData?.clientLogo || "./images/Hrms.jpg"}
                        alt="profile-image"
                        className="image"
                      />
                    </div>
                    <h3>Login</h3>
                  </div>

                  {errorMessage && (
                    <div className="alert alert-danger" role="alert">
                      {errorMessage}
                    </div>
                  )}

                  <div>
                    <div className="modern-input-group">
                      <input
                        name="username"
                        type="text"
                        placeholder="Enter your Username"
                        value={inputData.username}
                        onChange={handleChange}
                      />
                      <svg className="input-icon" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                      </svg>
                    </div>

                    <div className="modern-input-group">
                      <input
                        name="password"
                        type={showPassword ? "text" : "password"}
                        placeholder="Enter your Password"
                        value={inputData.password}
                        onChange={handleChange}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            handelSubmit(e);
                          }
                        }}
                      />
                      <svg className="input-icon" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z" />
                      </svg>

                      {/* Eye Icon */}
                      <span
                        onClick={() => setShowPassword((prev) => !prev)}
                        className="position-absolute top-50 end-0 translate-middle-y me-3"
                        style={{ cursor: "pointer", color: "#6c757d" }}
                      >
                        {showPassword ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
                      </span>
                    </div>

                    <button
                      type="button"
                      className="btn-modern-primary"
                      onClick={handelSubmit}
                    >
                      Submit
                    </button>

                    <div className="text-center">
                      <span
                        className="forgot-password-link"
                        onClick={() => navigate('/forgotPassword')}
                      >
                        Forgot Password?
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer className="modern-footer">
        <div className="footer-container">
          <div className="footer-column">
            <h3 className="footer-title">About Us</h3>
            <p className="footer-text">
              {clientData?.aboutUs || ""}
            </p>
          </div>

          <div className="footer-column">
            <h3 className="footer-title">Quick Links</h3>
            <ul className="footer-links">
              <li><a href="/#">Home</a></li>
              <li><a href="/#">Services</a></li>
              <li><a href="/#">About</a></li>
              <li><a href="/#">Contact</a></li>
              <li><a href="/#">Blog</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h3 className="footer-title">Contact Us</h3>
            <ul className="footer-contact">
              <li><span>Phone:</span> <a href={`tel:+${clientData?.clientPhoneNo || ""}`}>{clientData?.clientPhoneNo || ""}</a></li>
              <li><span>Email:</span> <a href={`mailto:${clientData?.clientEmail || ""}`}>{clientData?.clientEmail || ""}</a></li>
              <li><span>Address:</span>{clientData?.clientAddress || ""}</li>
            </ul>
          </div>

          <div className="footer-column">
            <h3 className="footer-title">Follow Us</h3>
            <div className="footer-social">
              <a href={clientData?.fbLink || ""} className="footer-social-link" target="_blank">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                </svg>
              </a>
              <a href={clientData?.linkedinLink || ""} className="footer-social-link" target="_blank">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                </svg>
              </a>
              <a href={clientData?.twitterLink || ""} className="footer-social-link" target="_blank">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
                </svg>
              </a>
              <a href={clientData?.instagramLink || ""} className="footer-social-link" target="_blank">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z" />
                </svg>
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Developed By: Elexyt PVT. LTD. | All rights reserved.</p>
        </div>
      </footer>
    </div >
  );
};

export default Signin;

